import { render, staticRenderFns } from "./ManagePartner.vue?vue&type=template&id=702371d4&scoped=true"
import script from "./ManagePartner.vue?vue&type=script&lang=js"
export * from "./ManagePartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702371d4",
  null
  
)

export default component.exports